import { InteractionType } from "@azure/msal-browser";
import { useMsalAuthentication } from "@azure/msal-react";
import { useTranslations } from "providers/Translations";

import { defaultScopes } from "./AuthenticationContext";

export const AuthError = () => {
  const { login } = useMsalAuthentication(InteractionType.Redirect, { scopes: defaultScopes });
  const i18n = useTranslations();
  return (
    <div className="auth-container login-failed">
      {i18n.Auth_LoginFailed}
      <button onClick={() => login(InteractionType.Redirect)}>{i18n.Auth_TryAgain}</button>;
    </div>
  );
};
